import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Landmark } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export function BankTransferOption({ form, formRef }: { form: any; formRef: React.RefObject<HTMLFormElement> }) {
  const { quote, promo, rewards, payload, clear, ship } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();
  const [cfg, setCfg] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/payments/bank-transfer").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg?.available || !quote || quote.total <= 0) return null;
  if (quote.total < cfg.min_total) return <p className="text-xs text-neutral-500" data-testid="bank-transfer-min-note">Bank transfer is available on orders of {money(cfg.min_total)} or more.</p>;
  const place = async () => {
    if (!formRef.current?.reportValidity()) return;
    setBusy(true);
    try {
      const r = await api.post("/checkout/bank-transfer", { ...form, ...ship, items: payload(), promo_code: promo || null, rewards: user ? rewards : null });
      clear();
      nav("/payment/bank-transfer", { state: r.data });
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="border border-neutral-200 bg-white p-4 space-y-3" data-testid="bank-transfer-option">
      <p className="text-xs text-neutral-600">Prefer to pay directly from your bank? We'll reserve your order and email our account details. Your order is confirmed once the transfer arrives (usually 1–2 business days).</p>
      <button type="button" onClick={place} disabled={busy} className="btn-line w-full py-4 text-xs tracking-[0.25em] uppercase flex items-center justify-center gap-3 disabled:opacity-60" data-testid="checkout-bank-transfer-button">
        <Landmark size={14} /> {busy ? "Placing order…" : `Pay ${money(quote.total)} by bank transfer`}
      </button>
    </div>
  );
}
